import * as React from 'react';
import cx from 'classnames';
import StringWidget from 'components/StringWidget';
import Loader from 'components/Common/Loader/Loader';
import Button from 'components/Button/Button';
import TextInput from 'components/TextInput/TextInput';
import { verifyUserAccountAction } from 'actions/LoginSignupActions/updateIdentityActions';
import { setUserPassword } from 'actions/LoginSignupActions/setPasswordActions';
import { doSignUp } from 'actions/LoginSignupActions/signupActions';
import { verifyLoginOtp } from 'actions/LoginSignupActions/verifyLoginOtpActions';
import { generateLoginOtp } from 'actions/LoginSignupActions/generateLoginOtpActions';
import { hideModal } from 'actions/modalActions';
import get from 'lodash/get';
import { isValidMobileNumber, isDigitsOnly, DIGITS_ONLY_REGEXP } from 'utils/validators';
import { addClass, removeClass } from 'utils/domHelper';
import { RightMarkIcon } from 'components/Icons/Icons';
import { getOmnitureLoginId } from '../LoginSignupAnalytics';
import { LoginViews } from '../LoginTypes';
import toastConfig from 'toasts.json';
export default class LoginVerificationView extends React.Component {
    constructor(props) {
        super(props);
        this.onTextChange = (value) => {
            this.setState(value);
        };
        this.handleOTPChange = ({ payloadKey = 'payload', valueKey = 'verificationCode', otpErrorKey = 'otpError', verifiedState = 'verified', churnEmailRequest }) => (value) => {
            const { extra, changeViewHandler, trackOmniture, pageType, loginSource, handleAPIRequest, handleAPIError } = this.props;
            const { [valueKey]: verificationCode } = this.state;
            const requestId = get(extra, [payloadKey, 'data', 'requestId'], '');
            const otpRegex = get(extra, [payloadKey, 'data', 'otpRegex'], '');
            const regex = new RegExp(`${otpRegex}$`, 'g');
            if (requestId && verificationCode !== value && regex.test(value)) {
                const loginId = isValidMobileNumber(extra.userName) ? `+91${extra.userName}` : extra.userName;
                ++this.count;
                // Tracking for OTP entered
                if (verificationCode) {
                    trackOmniture(extra.signup ? 'otp_entered_signup' : 'otp_entered_login', {
                        pageType,
                        loginSource,
                        loginId: getOmnitureLoginId(get(extra, 'userName'))
                    });
                }
                handleAPIRequest(verifyLoginOtp, {
                    otp: value,
                    otpRequestId: requestId,
                    loginId,
                    churnEmailRequest
                }, () => {
                    this.count = 0;
                    this.setState({ [verifiedState]: true, [otpErrorKey]: '' });
                }, payload => {
                    trackOmniture(extra.signup ? 'new_otp_verification_failed' : 'otp_verification_failed', {
                        pageType,
                        loginSource,
                        loginId: getOmnitureLoginId(get(extra, 'userName')),
                        attempt: this.count
                    });
                    const errorCode = get(payload, ['error', 'RESPONSE', 'errorCode']);
                    if (errorCode === 'LOGIN_1008') {
                        return this.setState({
                            [otpErrorKey]: payload.error.RESPONSE.message
                        });
                    }
                    if (errorCode === 'LOGIN_1006') {
                        return changeViewHandler({
                            view: LoginViews.MESSAGE_INFO,
                            extra: {
                                message: payload.error.RESPONSE.message
                            }
                        });
                    }
                    if (errorCode === 'LOGIN_1007') {
                        return this.setState({
                            [otpErrorKey]: <StringWidget strKey="loginOTPExpiredErrorMsg"/>
                        });
                    }
                    return handleAPIError(payload);
                }, extra.signup ? 'signup_otp_verified' : 'otp_verified');
            }
            this.onTextChange({ [valueKey]: value, [otpErrorKey]: '' });
        };
        this.handleSubmit = (e) => {
            e && e.preventDefault();
            if (!this.validateAllFields()) {
                return false;
            }
            const { extra = {}, styles, handleLoginSuccess, trackOmniture, pageType, loginSource, handleAPIRequest, handleAPIError } = this.props;
            const { verificationCode, emailVerificationCode, password } = this.state;
            const submitBtn = this.submitContainer;
            const requestId = get(extra, 'payload.data.requestId', '');
            addClass(submitBtn, styles['loading']);
            const loginId = isValidMobileNumber(extra.userName) ? `+91${extra.userName}` : extra.userName;
            const requestPayload = {
                loginId,
                otp: verificationCode,
                password: extra.unverified ? extra.password : password,
                otpRequestId: requestId
            };
            let targetFn = setUserPassword;
            if (extra.signup) {
                targetFn = doSignUp;
                requestPayload.emailId = extra.emailId;
            }
            else if (extra.unverified) {
                targetFn = verifyUserAccountAction;
            }
            else if (extra.churned) {
                requestPayload.otpRequestId = get(extra, ['mobilePayload', 'data', 'requestId']);
                requestPayload.emailOtpRequestId = get(extra, ['payload', 'data', 'requestId']);
                requestPayload.emailOtp = emailVerificationCode;
            }
            handleAPIRequest(targetFn, requestPayload, () => {
                handleAPIRequest(hideModal);
                typeof handleLoginSuccess === 'function' && handleLoginSuccess();
            }, payload => {
                removeClass(submitBtn, styles['loading']);
                const errorCode = get(payload, ['error', 'RESPONSE', 'errorCode']);
                if (errorCode === 'LOGIN_1009') {
                    return this.setState({ passwordError: payload.error.RESPONSE.message });
                }
                if (errorCode === 'LOGIN_1062') {
                    // New password is same as old password..
                    trackOmniture('loginverify_same_password', { pageType, loginSource, loginId: getOmnitureLoginId(loginId) });
                    // TODO: we can show inline error in this case. Need to correct TextInput to handle multiline error messages.
                    return handleAPIError(payload, '');
                }
                if (errorCode === 'LOGIN_1007') {
                    trackOmniture('loginverify_otp_expired', { pageType, loginSource, loginId: getOmnitureLoginId(loginId) });
                    return this.setState({ otpError: <StringWidget strKey="loginOTPExpiredErrorMsg"/> });
                }
                return handleAPIError(payload, extra.signup ? 'signup_failed' : 'login_failed');
            }, extra.signup ? 'signup_success' : 'reset_pwd_success');
            return false;
        };
        this.handleRegenerateOTP = ({ churnEmailRequest = false, payloadKey = 'payload', valueKey = 'verificationCode', otpErrorKey = 'otpError', verifiedState = 'verified' }) => (e) => {
            e && e.preventDefault();
            const { changeViewHandler, extra, toast, trackOmniture, pageType, loginSource, handleAPIRequest, handleAPIError } = this.props;
            const { userName, accountState } = extra;
            this.count = 0;
            trackOmniture(extra.signup ? 'signup_resend_otp_clicked' : 'resend_otp_clicked', {
                pageType,
                loginSource,
                loginId: getOmnitureLoginId(userName)
            });
            const loginId = isValidMobileNumber(userName) ? `+91${userName}` : userName;
            const _reqBody = `loginId=${loginId}&state=${accountState}&churnEmailRequest=${churnEmailRequest}`;
            handleAPIRequest(generateLoginOtp, _reqBody, payload => {
                if (churnEmailRequest) {
                    toast.show(toastConfig.verificationCodeSentMsg, { userName: get(payload, ['data', 'emailMask']) });
                }
                else {
                    toast.show(toastConfig.verificationCodeSentMsg, { userName });
                }
                this.setState({
                    [verifiedState]: false,
                    [otpErrorKey]: '',
                    passwordError: '',
                    [valueKey]: ''
                });
                return changeViewHandler({
                    view: LoginViews.VERIFICATION,
                    extra: Object.assign({}, extra, { [payloadKey]: payload })
                });
            }, handleAPIError, extra.signup ? 'new_otp_sent' : 'otp_sent', '', loginId);
            e.preventDefault();
        };
        this.submitContainerRef = (c) => {
            this.submitContainer = c;
        };
        this.handleBtnClick = (e) => this.props.changeViewHandler({
            view: get(this.props, ['extra', 'signup']) ? LoginViews.LOGIN : LoginViews.SIGNUP,
            extra: {}
        }, e);
        this.handleChangeUserNameClick = (e) => {
            e.preventDefault();
            const { compactView, changeViewHandler } = this.props;
            changeViewHandler({
                view: get(this.props, ['extra', 'signup']) || compactView ? LoginViews.SIGNUP : LoginViews.LOGIN,
                extra: {}
            });
        };
        this.handleUserNameChange = (value) => value.replace(/\D+/g, '');
        this.handlePasswordChange = (password) => this.onTextChange({
            password,
            passwordError: ''
        });
        this.renderResendBtn = (inlineText = false, otpParams = {}) => {
            const { compactView, styles } = this.props;
            return (<a href="#" className={cx(styles['input-action-txt'], { [styles['pull-right']]: !compactView && !inlineText }, { [styles['append-txt']]: compactView || inlineText })} onClick={this.handleRegenerateOTP(otpParams)} tabIndex={-1}>
				<StringWidget strKey="loginResendOtpText"/>
			</a>);
        };
        this.renderOTPInputField = ({ payloadKey, verifiedState = 'verified', churnEmailRequest, placeholderKey = 'loginOTPPlaceholder', valueKey = 'verificationCode', otpErrorKey = 'otpError', churned, wrapperClass, autoFocus = true }) => {
            const { compactView, styles } = this.props;
            const { [valueKey]: value, [otpErrorKey]: error, [verifiedState]: verified } = this.state;
            return (<TextInput onTextChange={this.handleOTPChange({ valueKey, otpErrorKey, payloadKey, verifiedState, churnEmailRequest })} placeholder={<StringWidget strKey={placeholderKey}/>} pattern={DIGITS_ONLY_REGEXP} autoComplete="on" autoFocus={autoFocus} maxLength="6" value={value} readOnly={verified} errorMsg={error} appendInfo={compactView || churned || verified} className={styles['form-input']} wrapperClass={cx(wrapperClass, styles['form-input-wrap'])}>
				{verified ? (<span className={cx(styles['success-otp'], styles['append-txt'])}>
						<RightMarkIcon />
					</span>) : compactView || churned ? (this.renderResendBtn(churned, {
                churnEmailRequest,
                payloadKey,
                valueKey,
                otpErrorKey,
                verifiedState
            })) : null}
			</TextInput>);
        };
        this.validateAllFields = () => {
            let valid = true;
            const { extra, trackOmniture, pageType, loginSource } = this.props;
            const { verificationCode, emailVerificationCode, password, verified, emailVerified } = this.state;
            if (!verificationCode || !verified) {
                this.setState({
                    otpError: <StringWidget strKey="loginInvalidOTP"/>
                });
                valid = false;
                trackOmniture('otp_verification_failed_other', {
                    pageType,
                    loginSource,
                    loginId: getOmnitureLoginId(get(extra, 'userName'))
                });
            }
            else if (extra.churned && (!emailVerificationCode || !emailVerified)) {
                this.setState({
                    emailOtpError: <StringWidget strKey="loginInvalidOTP"/>
                });
                valid = false;
                trackOmniture('otp_verification_failed_other', {
                    pageType,
                    loginSource,
                    loginId: getOmnitureLoginId(get(extra, 'userName'))
                });
            }
            else if (!extra.unverified && !password) {
                this.setState({
                    passwordError: <StringWidget strKey="loginInvalidPassword"/>
                });
                valid = false;
            }
            return valid;
        };
        this.count = 0;
        this.state = {
            verified: false,
            password: '',
            mobileNumber: '',
            otpError: '',
            passwordError: '',
            verificationCode: ''
        };
    }
    render() {
        const { extra, styles, compactView } = this.props;
        const isUserNameDigitsOnly = isDigitsOnly(extra ? extra.userName : '');
        const emailMask = get(extra, ['payload', 'data', 'emailMask'], '');
        const { password, passwordError, emailOtpError } = this.state;
        const churned = extra.churned;
        const payloadKey = churned ? 'mobilePayload' : 'payload';
        let submitBtnStrKey = 'loginTitleTxt';
        if (extra.signup) {
            submitBtnStrKey = 'signupBtnTxt';
        }
        else if (extra.unverified) {
            submitBtnStrKey = 'loginVerifyBtnTxt';
        }
        else if (extra.reactivate) {
            submitBtnStrKey = 'loginReactivateBtnTxt';
        }
        return (<form onSubmit={this.handleSubmit}>
				<TextInput readOnly prependInfo={isUserNameDigitsOnly} autoComplete="username" value={extra.userName || ''} appendInfo="true" onTextChange={this.handleUserNameChange} placeholder={<StringWidget strKey={isUserNameDigitsOnly ? 'loginVerificationMobilePlaceholderTxt' : 'loginVerificationEmailPlaceholderTxt'}/>} className={styles['form-input']} wrapperClass={styles['form-input-wrap']}>
					{isUserNameDigitsOnly ? <span className={styles['prepend-txt']}>+91</span> : null}
					<a href="#" className={cx(styles['append-txt'], styles['input-action-txt'])} onClick={this.handleChangeUserNameClick} tabIndex={-1}>
						<StringWidget strKey="loginChangeUserNameTxt"/>
					</a>
				</TextInput>

				{compactView || churned ? null : (<div className={styles['verification-info-txt']}>
						<StringWidget strKey={isUserNameDigitsOnly ? 'loginOTPSentToMobileMsg' : 'loginOTPSentToEmailMsg'}/>
						{this.renderResendBtn()}
					</div>)}
				{this.renderOTPInputField(Object.assign({ payloadKey,
            churned }, (churned && { placeholderKey: 'loginMobileOTPPlaceholder' })))}
				{churned && (<div>
						{this.renderOTPInputField({
            churnEmailRequest: true,
            autoFocus: false,
            verifiedState: 'emailVerified',
            valueKey: 'emailVerificationCode',
            otpErrorKey: 'emailOtpError',
            placeholderKey: 'loginEmailOTPPlaceholder',
            wrapperClass: styles['churn-email-field'],
            churned
        })}
						<StringWidget className={cx(styles['churn-email-info'], { [styles['error']]: !!emailOtpError })} strKey="loginEmailOTPInfoTxt" attributes={{ email: emailMask }}/>
					</div>)}
				{extra.unverified ? null : (<TextInput type="password" value={password} onTextChange={this.handlePasswordChange} errorMsg={passwordError} className={styles['form-input']} wrapperClass={styles['form-input-wrap']} placeholder={<StringWidget strKey="loginSetPasswordPlaceholder"/>}/>)}

				<div ref={this.submitContainerRef} className={styles['form-btn-wrap']}>
					<Button type="submit" secondary className={styles['submit-btn']}>
						<Loader stroke="#fff" className={styles['loader-icon']}/>
						<StringWidget strKey={submitBtnStrKey}/>
					</Button>
					{extra.unverified || extra.reactivate || compactView ? null : (<Button className={cx(styles['submit-btn'], styles['white-btn'], styles['change-view-btn'])} onClick={this.handleBtnClick}>
							{extra.signup ? (<StringWidget strKey="loginAlreadyHaveAccountBtnMsg"/>) : (<StringWidget strKey="loginNewUserBtnMsg"/>)}
						</Button>)}
				</div>
			</form>);
    }
}
LoginVerificationView.defaultProps = {
    extra: {
        payload: {
            data: {}
        }
    },
    trackOmniture: () => null
};
